module.exports = __webpack_public_path__ + "static/media/m_w_hb_0.14c11af8.png";